/* eslint-disable  @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable  @typescript-eslint/explicit-function-return-type */
import { RecentPublicSwaps } from '../../../components/SwapKiwi/RecentSwaps';

export const components = [
  {
    name: RecentPublicSwaps,
  },
];
